var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sale_scenario)?_c('div',{staticClass:"sale-scenario"},[_c('span',[_vm._v(" "+_vm._s(_vm.is_hotels() ? 'Vivamod' : _vm.get_config('site.brand'))+" Deal ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }